"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_schema_types_1 = require("@aurora/shared-generated/types/graphql-schema-types");
const types_1 = require("./types");
class BoldItalicStyle {
    constructor() {
        this.name = types_1.FontStyleName.BOLDITALIC;
        this.style = graphql_schema_types_1.FontStyle.Italic;
        this.weight = 700;
    }
}
exports.default = BoldItalicStyle;
//# sourceMappingURL=BoldItalicStyle.js.map